module.exports = __webpack_public_path__ + "img/SSL_blue.4bcb1746.png";